import { QueryClient } from "@tanstack/react-query";
import { retryIfServerError } from "src/queries/utils";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: retryIfServerError
    },
    mutations: {
      retry: retryIfServerError
    }
  }
});
